























import { Component, Vue, Prop } from 'vue-property-decorator'
import Pill from '../Pill/Pill.vue'
import * as db from '@shared/types/database'

@Component({ components: { Pill } })
export default class TestCard extends Vue {
  @Prop() readonly test!: db.Test
  @Prop() readonly projectId!: string

  get testLink () {
    return this.projectId ? this.projectId + '/tests/' + this.test.id : 'tests/' + this.test.id
  }
}
